export const getAccess = (permissions = {}, isAdmin = false) => {
  if (isAdmin) {
    return {
      reception: true,
      pharmacy: true,
      doctor: true,
      nurse: true,
      x_ray: true,
      ultrasounds: true,
      laboratory: true,
      echo: true,
      finance: true,
      hr: true,
      academic: true,
      dental: true,
      call_center: true,
      beauty: true,
      htPatient: true,
      operations: true,
      emergency: true,
      bedManagement: true,
      ipd: true,
      icu: true,
      reports: true,
      night_shift: true,
      night_shift_manage: true,
      is_staff: true,
      is_manager_in_call_center: true,
      call_center_admin: true,
    };
  }

  return {
    reception: permissions.reception || false,
    pharmacy: permissions.pharmacy || false,
    doctor: permissions.doctor || false,
    nurse: permissions.nurse || false,
    x_ray: permissions.x_ray || false,
    ultrasounds: permissions.ultrasounds || false,
    laboratory: permissions.laboratory || false,
    echo: permissions.echo || false,
    finance: permissions.finance || false,
    hr: permissions.hr || false,
    academic: permissions.academic || false,
    dental: permissions.dental || false,
    call_center: permissions.call_center || false,
    beauty: permissions.beauty || false,
    htPatient: permissions.htPatient || false,
    operations: permissions.operations || false,
      emergency: permissions.emergency || false,
      bedManagement: permissions.bedManagement || false,
      ipd: permissions.ipd || false,
      icu: permissions.icu || false,
      reports: permissions.reports || false,
      night_shift: permissions.night_shift || false,
      night_shift_manage: permissions.night_shift_manage || false,
      is_staff: permissions.is_staff || false,
    is_manager_in_call_center: permissions.is_manager_in_call_center || false,
    call_center_admin: permissions.call_center_admin || false,
  };
};
